export default __webpack_public_path__ + "static/media/cas5–Analysedesmarchés.015c9a36.svg";